import { Skeleton } from '@/components/ui/skeleton';

export const CompanyInformationSkeleton = () => (
  <section className="w-full">
    <div className="flex flex-col gap-3 px-5 pt-5 pb-3">
      <div className="flex justify-between items-start">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="flex gap-3">
          <Skeleton className="h-10 w-32" />
        </div>
      </div>
    </div>

    <div className="mx-5 border-b border-gray-200" />

    <div className="pt-5 px-5 space-y-6">
      <div className="space-y-2">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-64 w-full rounded-md" />
      </div>

      <div className="space-y-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-40 w-full rounded-md border-2 border-dashed" />
      </div>

      <div className="flex items-center space-x-2 pt-4">
        <Skeleton className="h-5 w-5 rounded" />
        <Skeleton className="h-5 w-48" />
      </div>
    </div>
  </section>
);
